import { AutoAwesome, ThumbDownOutlined, ThumbUpOutlined } from '@mui/icons-material';
import { IconButton, Typography, Stack } from '@mui/material';
import React, { useState } from 'react';
import { LoadingButton } from '@mui/lab';
import LogOnEnter from '../../CustomComponents/LogOnEnter';
import { useApiContext } from '../../Hooks/useApiContext';

function GenerativeItemDetails({ item }) {
    const [itemDetails, setItemDetails] = useState(item.generative_item_detail);
    const [hasUserVoted, setHasUserVoted] = useState(item.generative_item_detail?.has_user_vote || false);
    
    const { endpoints } = useApiContext();
    
    const [getGenerativeItemDetails, { isLoading: loadingDetails }] = endpoints.generateItemDetails.useLazyQuery();
    const [sendVote] = endpoints.sendGenerativeItemDetailVote.useMutation();
    const [logUserAction] = endpoints.logUserAction.useMutation();

    async function handleLoadGenerativeItemDetails() {
        getGenerativeItemDetails(item.id).unwrap().then((response) => {
            setItemDetails(response);
            logUserAction({
                action: 'generated_item_details',
                data: { itemId: item.id }
            });
        }).catch((error) => {
            console.error('Error generating item details:', error);
        });
    }

    async function handleVoteResponse(vote) {
        await sendVote({
            detailId: itemDetails.id,
            vote: vote,
        }).unwrap().then(() => {
            setHasUserVoted(true);
        }).catch((error) => {
            console.error('Error sending vote:', error);
        });
    }

    return (
        <LogOnEnter action='viewed_generative_details' data={{ item }}>
            <Stack spacing={2} p={2} sx={{ backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                <Typography variant='normal' sx={{ fontSize: '14px' }}><b>Additional Item Information </b></Typography>
                { itemDetails?.details &&
                    <>
                        <Typography variant='normal' sx={{ fontSize: '12px' }}><b>Item Name: </b>{JSON.parse(itemDetails?.details)['renamed_item']}</Typography>
                        <Typography variant='normal' sx={{ fontSize: '12px' }}><b>Item Details: </b>{JSON.parse(itemDetails?.details)['item_details']}</Typography>
                        <Typography variant='normal' sx={{ fontSize: '12px' }}><b>Item Usage: </b>{JSON.parse(itemDetails?.details)['item_usage']}</Typography>
                    </>
                }
                { itemDetails ? 
                    hasUserVoted ? <Typography variant='normal' sx={{ fontSize: '12px' }}>Feedback recorded! Thank you!</Typography> :
                        <Stack direction='row' spacing={1} sx={{ fontSize: '12px', alignItems: 'center' }}>
                            <Typography variant='normal' sx={{ fontSize: '12px' }}>Was this description helpful?</Typography>
                            <IconButton color='primary' onClick={() => handleVoteResponse('upvote')} size='small'>
                                <ThumbUpOutlined />
                            </IconButton>
                            <IconButton color='primary' onClick={() => handleVoteResponse('downvote')} size='small'>
                                <ThumbDownOutlined />
                            </IconButton>
                        </Stack>
                    :
                    <LoadingButton loading={loadingDetails} variant='outlined' sx={{ width: '75%', alignSelf: 'center' }} startIcon={<AutoAwesome />} onClick={handleLoadGenerativeItemDetails}>Get More Item Information</LoadingButton>
                }
            </Stack>
        </LogOnEnter>
    );
}

export default GenerativeItemDetails;
